import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { SkeletonLoaderErrorOptions, SkeletonLoaderService } from '@app/shared/services/skeleton-loader.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-skeleton-loader',
  templateUrl: './skeleton-loader.component.html',
  styleUrls: ['./skeleton-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatProgressSpinner, AsyncPipe],
})
export class SkeletonLoaderComponent implements OnInit, OnDestroy {
  private skeletonService = inject(SkeletonLoaderService);

  @Input() public observableKey: string;
  @Input() public loadingStyle: 'overlay' | 'spinner' = 'overlay';
  @Input() public errorOptions?: SkeletonLoaderErrorOptions;

  public isDoneLoading$: Observable<boolean>;
  public observable$: Observable<unknown>;

  public ngOnInit(): void {
    this.isDoneLoading$ = this.skeletonService.isLoading$(this.observableKey).pipe(map((isLoading) => !isLoading));
    this.skeletonService.load(this.observableKey, this.errorOptions);
  }

  public ngOnDestroy(): void {
    this.skeletonService.complete(this.observableKey);
  }
}
